import { Link } from 'react-router-dom';

import { cellActiveClasses, cellClasses } from 'components/common/Pagination/Pagination.classes';
import type { PaginationCellProps } from 'components/common/Pagination/Pagination.types';

/**
 * A single pagination cell. Presentational and navigation-agnostic: the active page renders as a
 * highlighted, non-interactive pill; any other page renders as a link to the supplied `href`.
 * Consumers own URL construction and click handling.
 */
export const PaginationCell = ({ children, href, isActive, title, onClick, ...rest }: PaginationCellProps) => {
  if (isActive) {
    return (
      <span aria-current="true" className={cellActiveClasses} data-test-id={rest['data-test-id']} data-page-number={rest['data-page-number']}>
        {children}
      </span>
    );
  }

  return (
    <Link
      to={href || ''}
      title={title}
      className={cellClasses}
      data-test-id={rest['data-test-id']}
      data-page-number={rest['data-page-number']}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
